import React from 'react';
import { Camera, Sparkles } from 'lucide-react';

const Gallery = ({ photos }) => {
  return (
    <section id="gallery" className="py-20 bg-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-20 right-0 w-64 h-64 bg-pink/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-80 h-80 bg-burgundy/10 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <Camera className="w-12 h-12 text-burgundy mx-auto" strokeWidth={1.5} />
          </div>
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-burgundy mb-4">
            Gallery
          </h2>
          <p className="text-xl text-gray-700">
            Moments from shows, events, and behind the scenes
          </p>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {photos.map((photo, index) => (
            <div
              key={photo.id}
              className={`group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 ${
                index === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
            >
              {/* Image */}
              <div className="relative aspect-square overflow-hidden bg-gradient-to-br from-burgundy/10 to-pink/10">
                <img
                  src={photo.url}
                  alt={photo.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-burgundy/70 via-burgundy/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                  <div className="text-white">
                    <p className="text-sm font-medium">{photo.alt}</p>
                  </div>
                </div>

                {/* Decorative corner */}
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-md">
                  <Sparkles className="w-4 h-4 text-burgundy" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Instagram CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">See more on Instagram</p>
          <a
            href="https://www.instagram.com/funnybysurname_comedy/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-3 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-500 text-white rounded-full font-semibold hover:scale-105 transition-transform duration-300 shadow-lg"
          >
            @funnybysurname_comedy
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
